<template>
    <span>
      <a class="tdclickable data-table-action"
         v-b-tooltip.hover
         @click="print"
         :title="$t('print')">
      <PrintSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('print') }}</span>
        </a>
    </span>
</template>

<script setup>
import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import JwtService from "@/services/jwt.service"

const props = defineProps({
  object: {
    type: Object
  }
})

const print = async () => {
  let link = JwtService.getPrintPrelink(null, true)
  const doc_type = 'custom'
  const patientId = 1097445 // we just take Dmitry Ton form 1843 as an example
  const visit_id = `?custom_id=${props.object.id}`
  window.open(link+'/document/'+patientId+'/'+doc_type + visit_id, '_blank')
}
</script>
